import { IApplicationState } from 'shared/types/redux';

export const selectUserType = (state: IApplicationState) => {
  return state.user.userType;
};
